export const labels = {
	filters: {
		label: "Label.MobileCreator.BottomMenu.Filters",
		default: "Filters",
	},
	brightness: {
		label: "Label.MobileCreator.BottomMenu.Brightness",
		default: "Brightness",
	},
	saturation: {
		label: "Label.MobileCreator.BottomMenu.Saturation",
		default: "Saturation",
	},
	contrast: {
		label: "Label.MobileCreator.BottomMenu.Contrast",
		default: "Contrast",
	},
} as const;
